<template>
  <table
    :style="styleObject"
    cellspacing="0"
    cellpadding="0"
    border="0"
  >
    <colgroup>
      <col
        v-for="column in columns"
        :key="column.key"
        :width="setCellWidth(column)">
    </colgroup>
    <tbody :class="[cssClasses.tbody]">
      <template v-for="(row, index) in data">
        <table-row
          :key="row.id"
          :columns="columns"
          :row="row"
          :row-index="index"
        />
      </template>
    </tbody>
  </table>
</template>

<script>
import TableRow from './table-row.vue';
import Expand from './expand';

import Mixin from './mixin';

export default {
  name: 'TableBody',
  components: {
    TableRow, Expand,
  },
  mixins: [Mixin],
  inject: ['table', 'cssClasses'],
  props: {
    columns: { type: Array, required: true },
    data: { type: Array, required: true }, // data
    styleObject: { type: Object, required: true },
  },
  computed: {
    // expandRender() {
    //   let renderExpanded = () => '';
    //   this.columns.forEach(({ type, render }) => {
    //     if (type === 'expand' && render) renderExpanded = render;
    //   });
    //   return renderExpanded;
    // },
  },
  methods: {
    // rowExpanded(index) {
    //   return this.table.rowProps[index] && this.table.rowProps[index].isExpanded;
    // },
  },
};
</script>
